// Roles del personal y permisos por módulo (espejo de backend/core/permisos.py)
export const ROLES = {
  admin: { label: 'Administrador', plural: 'Administradores' },
  supervisor: { label: 'Supervisor General', plural: 'Supervisores Generales' },
  supervisor_regional: { label: 'Supervisor Regional', plural: 'Supervisores Regionales' },
  auditor: { label: 'Auditor', plural: 'Auditores' },
  secretaria: { label: 'Secretaría', plural: 'Secretaría' },
  tecnico: { label: 'Técnico', plural: 'Técnicos' },
};

export const rolLabel = (rol) => ROLES[rol]?.label || rol || '';

const SUPERVISION = ['admin', 'supervisor', 'supervisor_regional'];
const GESTION = [...SUPERVISION, 'secretaria'];

// módulo -> roles que lo ven/usan
const MODULOS = {
  dashboard: SUPERVISION,
  clientes: [...GESTION, 'auditor'],          // auditor: sólo lectura (ver locales / historial)
  clientes_gestion: GESTION,                  // alta/edición de clientes y locales
  clientes_eliminar: ['admin'],
  programacion: GESTION,
  programacion_eliminar: GESTION,
  mis_servicios: ['tecnico'],
  mi_asistencia: ['tecnico', 'supervisor', 'supervisor_regional', 'auditor', 'secretaria'],
  planilla_tecnica: ['tecnico', 'admin', 'supervisor', 'supervisor_regional'],
  historial: [...GESTION, 'auditor'],
  historial_eliminar: ['admin'],
  aprobaciones: SUPERVISION,
  editar_planilla: SUPERVISION,
  enviar_correo: GESTION,
  stock: ['admin', 'supervisor'],
  rendimiento: SUPERVISION,
  auditoria_servicio: [...SUPERVISION, 'auditor'],  // pestaña independiente para el auditor
  tendencias: SUPERVISION,
  planos: SUPERVISION,                       // el técnico ve el plano sólo dentro de la Planilla Técnica
  papelera: ['admin', 'supervisor'],
  mapa: SUPERVISION,
  gestion_interna: [...GESTION, 'auditor'],
  certificaciones: GESTION,
  configuracion: ['admin'],
};

const puedePorRol = (user, modulo) => !!user && (MODULOS[modulo] || []).includes(user.rol);

// Pestañas (módulos de navegación) que el administrador puede habilitar/deshabilitar por usuario
// (supervisores, auditores y secretaría). Se ofrecen TODAS; por defecto quedan las propias del rol.
export const PESTANAS_CONFIGURABLES = [
  { key: 'dashboard', label: 'Dashboard' }, { key: 'clientes', label: 'Clientes' }, { key: 'programacion', label: 'Programación' },
  { key: 'mis_servicios', label: 'Mis Servicios' }, { key: 'mi_asistencia', label: 'Mi Asistencia' }, { key: 'planilla_tecnica', label: 'Planilla Técnica' },
  { key: 'historial', label: 'Historial' }, { key: 'stock', label: 'Stock' }, { key: 'aprobaciones', label: 'Aprobaciones' },
{ key: 'rendimiento', label: 'Rendimiento' }, { key: 'auditoria_servicio', label: 'Auditoría de Servicio' },
  { key: 'tendencias', label: 'Tendencias' }, { key: 'planos', label: 'Planos interactivos' }, { key: 'mapa', label: 'Mapa' },
  { key: 'gestion_interna', label: 'Gestión interna' }, { key: 'papelera', label: 'Papelera' }, { key: 'configuracion', label: 'Configuración' },
];

// Subpestañas de cada pestaña: al tildar la pestaña vienen todas; las destildadas sólo se ocultan en pantalla.
// `padre` = subpestaña dentro de otra (p. ej. las de Certificaciones dentro de Clientes).
export const SUBPESTANAS = {
  clientes: [{ key: 'general', label: 'General' }, { key: 'contrato', label: 'Contrato' }, { key: 'avisos', label: 'Avisos' },
    { key: 'certificaciones', label: 'Certificaciones' }, { key: 'cert_emitir', label: 'Emitir', padre: 'certificaciones' },
    { key: 'cert_registro', label: 'Control por local', padre: 'certificaciones' }, { key: 'cert_historial', label: 'Historial', padre: 'certificaciones' },
    { key: 'cert_pendientes', label: 'Pendientes', padre: 'certificaciones' }],
  mis_servicios: [{ key: 'mi-actividad', label: 'Mi actividad' }, { key: 'ordenes', label: 'Órdenes' }, { key: 'aprobaciones', label: 'Aprobaciones' }, { key: 'otros', label: 'Otros' }],
  historial: [{ key: 'servicios', label: 'Servicios' }, { key: 'correos', label: 'Correos enviados' }],
  stock: [{ key: 'stock', label: 'Stock actual' }, { key: 'registro', label: 'Registro de movimientos' }, { key: 'tendencias', label: 'Tendencias y análisis' }],
  aprobaciones: [{ key: 'pendientes', label: 'Pendientes' }, { key: 'rechazadas', label: 'Rechazadas' }, { key: 'marcaciones', label: 'Marcaciones' }],
  rendimiento: [{ key: 'asistencia', label: 'Asistencia' }, { key: 'reportes', label: 'Reportes' }, { key: 'amonestaciones', label: 'Amonestaciones' },
    { key: 'auditoria-servicio', label: 'Auditoría de servicio' }, { key: 'control-tecnico', label: 'Control técnico' },
    { key: 'control-unidades', label: 'Control de unidades' }, { key: 'conclusiones', label: 'Conclusiones' }],
  tendencias: [{ key: 'visitas', label: 'Visitas' }, { key: 'insectos', label: 'Insectos' }, { key: 'roedores', label: 'Roedores' },
    { key: 'quimicos', label: 'Químicos' }, { key: 'recomendaciones', label: 'Recomendaciones' }],
  planos: [{ key: 'plano', label: 'Plano interactivo' }, { key: 'mapeos', label: 'Mapeos' }],
  mapa: [{ key: 'panorama', label: 'Panorama general' }, { key: 'optimizador', label: 'Optimizador de rutas' },
    { key: 'cercanas', label: 'Rutas cercanas' }, { key: 'monitoreo', label: 'Monitoreo de personal' }],
  gestion_interna: [{ key: 'mias', label: 'Para mí' }, { key: 'enviadas', label: 'Enviadas por mí' }, { key: 'todas', label: 'Todas' }],
};
export const claveSub = (tab, sub) => `${tab}.${sub}`;
// ¿Ve la subpestaña? Admin y técnico siempre; el resto, salvo que el admin la haya destildado (o a su subpestaña madre).
export const veSub = (user, tab, sub) => {
  if (!user || ROLES_PESTANAS_FIJAS.includes(user.rol)) return true;
  const ocultas = Array.isArray(user.subpestanas_ocultas) ? user.subpestanas_ocultas : [];
  const padre = (SUBPESTANAS[tab] || []).find((s) => s.key === sub)?.padre;
  return !ocultas.includes(claveSub(tab, sub)) && (!padre || !ocultas.includes(claveSub(tab, padre)));
};
// Subpestaña inicial: la preferida si la ve; si no, la primera visible del mismo nivel
export const primeraSub = (user, tab, preferida) => {
  if (veSub(user, tab, preferida)) return preferida;
  const nivel = (SUBPESTANAS[tab] || []).find((s) => s.key === preferida)?.padre;
  return (SUBPESTANAS[tab] || []).find((s) => s.padre === nivel && veSub(user, tab, s.key))?.key || preferida;
};
export const ROLES_PESTANAS_FIJAS = ['admin', 'tecnico'];
const esPestana = (modulo) => PESTANAS_CONFIGURABLES.some((p) => p.key === modulo);
const listaAsignada = (user) => (user && !ROLES_PESTANAS_FIJAS.includes(user.rol) && Array.isArray(user.pestanas_visibles) ? user.pestanas_visibles : null);

// Pestañas que el rol muestra en el menú si el admin no configuró nada
const OCULTAS_POR_DEFECTO = { auditor: ['clientes'], admin: ['auditoria_servicio'], supervisor: ['auditoria_servicio'], supervisor_regional: ['auditoria_servicio'], tecnico: ['mi_asistencia'] };
export const pestanasPorDefecto = (rol) => PESTANAS_CONFIGURABLES
  .filter((p) => (MODULOS[p.key] || []).includes(rol) && !(OCULTAS_POR_DEFECTO[rol] || []).includes(p.key))
  .map((p) => p.key);
export const pestanasEfectivas = (user) => listaAsignada(user) || pestanasPorDefecto(user?.rol);
export const muestraPestana = (user, key) => pestanasEfectivas(user).includes(key);

// Permiso efectivo: si el admin configuró pestañas para este usuario, manda esa lista (puede ampliar o acotar el rol);
// si no, rige el rol. Los permisos que no son pestañas (eliminar, editar planilla…) siempre dependen del rol.
export const puede = (user, modulo) => {
  if (!user) return false;
  const lista = listaAsignada(user);
  if (lista && esPestana(modulo)) return lista.includes(modulo);
  return puedePorRol(user, modulo);
};

export const esSupervision = (user) => puede(user, 'aprobaciones');
export const esRegional = (user) => user?.rol === 'supervisor_regional';

// Pantalla inicial según rol
const RUTA_MODULO = { dashboard: '/dashboard', clientes: '/clientes', programacion: '/programacion', mis_servicios: '/mis-servicios', mi_asistencia: '/mi-asistencia', planilla_tecnica: '/planilla-tecnica',
  historial: '/historial', stock: '/stock', aprobaciones: '/aprobaciones', rendimiento: '/rendimiento',
  auditoria_servicio: '/auditoria-servicio', tendencias: '/tendencias', planos: '/planos', mapa: '/mapa', gestion_interna: '/gestion-interna',
  papelera: '/papelera', configuracion: '/usuarios' };

export const rutaInicio = (user) => {
  if (!user) return '/login';
  if (user.rol === 'tecnico') return '/mis-servicios';
  const preferida = user.rol === 'auditor' ? 'auditoria_servicio' : user.rol === 'secretaria' ? 'clientes' : 'dashboard';
  if (puede(user, preferida)) return RUTA_MODULO[preferida];
  const primera = PESTANAS_CONFIGURABLES.find((p) => puede(user, p.key) && RUTA_MODULO[p.key]);
  return primera ? RUTA_MODULO[primera.key] : SIN_SECCIONES;
};
export const SIN_SECCIONES = '/sin-secciones';

// Roles que marcan asistencia / tienen coordenadas GPS personales (todos salvo administrador)
export const ROLES_GPS = ['tecnico', 'supervisor', 'supervisor_regional', 'auditor', 'secretaria'];
